import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    TextField,
    Button,
    Box,
    Typography,
    Snackbar,
    Alert,
} from '@mui/material';
import { styled, keyframes } from '@mui/system';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate } from "react-router-dom";
import { Notyf } from 'notyf';
import MaterialTable from '../Addform/Tables/MaterialTable';


const slideInFromLeft = keyframes`
  0% {
    transform: translateX(-20px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`;

const AnimatedTypography = styled(Typography)(({ theme }) => ({
    animation: `${slideInFromLeft} 0.5s ease-out`,
}));


const AddProduct = () => {
    const [user, setUser] = useState({});
    const [token, setToken] = useState(() => localStorage.getItem('token') || null);
    const navigate = useNavigate();
    const [material, setMaterial] = useState('');
    const [price, setPrice] = useState('');
    const [code, setCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [alertOpen, setAlertOpen] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false); 
    const [snackbarMessage, setSnackbarMessage] = useState(''); 
    const [snackbarSeverity, setSnackbarSeverity] = useState('success'); 
    const notyf = new Notyf({
        position: { x: 'left', y: 'bottom' },
        duration: 3000,
      });

    const handleSnackbar = (message, severity) => {
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setSnackbarOpen(true);
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    useEffect(() => {
        const fetchProfile = async () => {
          const token = localStorage.getItem("token");
    
          if (!token) {
            navigate("/"); 
            return;
          }
    
          try {
            const response = await axios.get("https://admin.bizstor.lk/public/api/profile", {
              headers: { Authorization: `Bearer ${token}` },
            });
            setUser(response.data);
          } catch (error) {
            if (error.response && error.response.status === 401) {
              localStorage.removeItem("token");
              navigate("/"); 
            }
          }
        };
    
        fetchProfile();
      }, []);

    const handleSubmit = async () => {
        setLoading(true);


        const data = new FormData();
        data.append('usertoken', user.id);
        data.append('material', material);
        data.append('price', price);
        data.append('code', code);

        try {
            const response = await axios.post('https://admin.bizstor.lk/public/api/save-material', data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            setMaterial('');
            setPrice('');
            setCode('');

            notyf.success('Material added successfully!');
            setLoading(false);

        } catch (error) {
            notyf.error('Something went wrong! try again');

        } finally {
            setLoading(false);
        }
    };

    
    return (
        <Box sx={{mt:10}}>
             <AnimatedTypography
                component="h1"
                sx={{
                    ml: { xs: 2, sm: 3 }, 
                    mt: { xs: 2, sm: 3 },
                    color: '',
                    letterSpacing: '0.01em',
                    fontSize: { xs: '20px', sm: '24px' }, 
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <HomeIcon
                        sx={{
                            ml: 1,
                            fontSize: '18px',
                            color: '#6d7081',
                        }}
                    />
                    <Typography
                        component="span"
                        sx={{
                            ml: 0.5,
                            fontSize: '14px',
                            color: '#6d7081',
                        }}
                    >
                        - Add - Material
                    </Typography>
                </Box>
            </AnimatedTypography>
            {/**<AnimatedTypography
                component="h1"
                sx={{
                    ml: 3,
                    mt: 3,
                    fontSize: '1rem',      // Adjust font size as needed
                    color: 'secondary.main', // Use theme color or specify a color like '#333'
                    letterSpacing: '0.01em' // Adjust letter spacing as needed
                }}
            >
                Dashboard / Add / Product
            </AnimatedTypography>*/}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: {sm:'95%',xs:'90%'},
                    maxWidth: 'auto',
                    margin: 'auto',
                    padding: '10px',
                    bgcolor: 'background.paper',
                    border: '1px solid #EDF2F7',
                    borderRadius: '16px',
                    marginTop: '30px',
                    position: 'relative'
                }}
            >
                <Typography variant="h5">
                    
                </Typography>
                {/**<hr style={{ borderTop: '1px solid #6d7081', width: '100%', margin: '10px 0' }} />*/}
                <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center', // Align items vertically
                            '@media (max-width: 600px)': {
                              margin: 'auto',
                            },
                            color: '#1e293b',
                            ml:2
                        }}
                    >
                        <h2>Add Material</h2>
                    </Box>
                <Box
                    sx={{
                        m: 2
                    }}
                >
                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, marginBottom: '20px', marginTop: '20px' }}>
                    <TextField
                        label="Material Name"
                        value={material}
                        onChange={(e) => setMaterial(e.target.value)}
                        variant="outlined"
                        fullWidth
                        size="small"
                        sx={{ marginBottom: { xs: '10px', sm: '0' }, marginRight: { sm: '10px' } }} 
                    />

                    <TextField
                        label="Price for one unit"
                        type="number"
                        value={price}
                        onChange={(e) => setPrice(e.target.value)}
                        variant="outlined"
                        fullWidth
                        size="small"
                        sx={{ marginBottom: { xs: '10px', sm: '0' }, marginLeft: { sm: '10px' } }} 
                    />

                    <TextField
                        label="Material Code"
                        type="number"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        variant="outlined"
                        fullWidth
                        size="small"
                        sx={{ marginBottom: { xs: '10px', sm: '0' }, marginLeft: { sm: '10px' } }} 
                    />
                </Box>
                </Box>

                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        style={{
                            backgroundColor: '#4287f5',
                            color: 'white',
                            marginTop: '30px',
                            borderRadius: '20px',
                            padding: '8px 24px',
                            '&:hover': {
                                backgroundColor: '#356bc4',
                            },
                            marginBottom: { xs: '8px', sm: '0' }
                        }}                    >
                        Add Material
                    </Button>
                </div>

                {loading && (
                    <Box sx={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: 'white',
                        zIndex: 9999
                    }}>
                        <l-trio
                            size="50"
                            speed="1.3"
                            color="red"
                        ></l-trio>
                    </Box>
                )}

                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={6000}
                    onClose={handleSnackbarClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                >
                    <Alert
                        onClose={handleSnackbarClose}
                        severity={snackbarSeverity}
                        sx={{
                            width: '100%',

                        }}
                    >
                        {snackbarMessage}
                    </Alert>
                </Snackbar>
            </Box>
            <MaterialTable />
        </Box>
    );
};

export default AddProduct;
